import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { TipoTalonarioLabels } from '@tivic-team/manager-ts/dist/mob/enums/talonario/tipo-talonario.enum';

@Component({
  selector: 'tipo-talao',
  templateUrl: './tipo-talao.component.html',
  styleUrls: ['./tipo-talao.component.scss']
})
export class TipoTalaoComponent implements OnInit {

  get nmTipoTalao() {
    if (!this.formGroup || !this.formGroup.get('tpTalao') || this.formGroup.get('tpTalao').value == null) {
      return '';
    }
    
    return TipoTalonarioLabels.get(this.formGroup.get('tpTalao').value);
  }
  
  formGroup: FormGroup;

  constructor(
    private _controlContainer: ControlContainer
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }
}
